import { AppContext } from '../contexts/appData';

const COM_LAYER_KEY = 'SiouxlandAndroidComLayer';

export const Android = {
    isEmbedded: () => COM_LAYER_KEY in window,
    setStatusBarColor: (newColor: string) => {
        if (!Android.isEmbedded()) return;

        (window as any)[COM_LAYER_KEY].setStatusBarColor(newColor);
    },
    getFirebaseToken: () => {
        if (!Android.isEmbedded()) return;
        const token = (window as any)[COM_LAYER_KEY].getFirebaseToken();

        return token;
    },
    handleNewFirebaseToken: (token: string, context: AppContext) => {
        context.handleNewFirebaseTokenAsync(token)
            .then(() => console.log('FCM token has been updated by the Android Application'));
    }
};
